/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('AclSelectorCtrl', function($scope, $routeParams, Search, Activity, Module) {
    $scope.all           = [];
    $scope.possible_acls = [];
    if ($scope.params['wall'] != null) { $scope.type          = $scope.params['wall']; }

    $scope.userFilter = function(query) {
        if ('' === query) { query = '*'; }
        return Search
        .get({
            query,
            from: 0,
            size: 50}).$promise
        .then(users => $scope.all = users.hits.map(user => user._source.login));
    };

    $scope.fillPossibleAcls = function() {
        if ('module' === $scope.type) {
            return Module
            .getPossibleMetaAcls({
                module_id:   $scope.params.module_id})
            .$promise
            .then(possible_acls => $scope.possible_acls = possible_acls);
        } else {
            return Activity
            .getPossibleMetaAcls({
                module_id:   $scope.params.module_id,
                activity_id: $scope.params.activity_id}).$promise
            .then(possible_acls => $scope.possible_acls = possible_acls);
        }
    };

    $scope.filterFromModules = function(query) {
        if (0 === $scope.possible_acls.length) { $scope.fillPossibleAcls(); }
        return $scope.all = $scope.possible_acls.filter(acl => -1 !== acl.indexOf(query));
    };

    return $scope.refreshAll = function(query) {
        if ('user' === $scope.type) { $scope.userFilter(query); }
        if (['activity', 'stage', 'module'].includes($scope.type)) { return $scope.filterFromModules(query); }
    };
});
